import * as icons from "@fortawesome/free-solid-svg-icons/index";

const iconsArray = Object.entries(icons).map( icon => {return icon} );

export default iconsArray;
